(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["poster-combo-offers"] && !Shopify.designMode) return;
  try {
    class PosterComboOffers extends HTMLElement {
    connectedCallback() {
      this.offerSets = {
        A4: [
          { tier: '1', label: 'Buy 2 Get 2 Free', quantity: 4, price: '158', unitPrice: '39.50', discountCode: '', ribbon: 'MOST POPULAR' },
          { tier: '2', label: 'Buy 3 Get 3 Free', quantity: 6, price: '237', unitPrice: '39.50', discountCode: '', ribbon: 'BIGGER PACK' },
          { tier: '3', label: 'Buy 5 Get 5 Free', quantity: 10, price: '395', unitPrice: '39.50', discountCode: '', ribbon: 'MAX SAVINGS' }
        ],
        A3: [
          { tier: '1', label: 'Buy 2 Get 2 Free', quantity: 4, price: '238', unitPrice: '59.50', discountCode: '', ribbon: 'MOST POPULAR' },
          { tier: '2', label: 'Buy 3 Get 3 Free', quantity: 6, price: '357', unitPrice: '59.50', discountCode: '', ribbon: 'BIGGER PACK' },
          { tier: '3', label: 'Buy 5 Get 5 Free', quantity: 10, price: '595', unitPrice: '59.50', discountCode: '', ribbon: 'MAX SAVINGS' }
        ]
      };
      this.cards = Array.from(this.querySelectorAll('[data-tier]'));
      this.cardsContainer = this.querySelector('.poster-combo-offers__cards');
      this.heading = this.querySelector('[data-combo-heading]');
      this.subheading = this.querySelector('[data-combo-subheading]');
      this.progress = this.querySelector('[data-combo-progress]');
      this.productForms = this.findProductForms();
      this.boundProductForms = new Set();
      this.cartCheckTimer = null;
      this.lastSelectedQuantity = null;
      this.handleDocumentChange = (event) => this.handleVariantChange(event);
      this.handleCartUpdate = () => this.updateProgress();
      this.handleProductFormSubmit = () => this.monitorCartAfterSubmit();
      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectOffer(card, true));
        card.addEventListener('keydown', (event) => this.handleKeydown(event, card));
      });
      document.addEventListener('change', this.handleDocumentChange);
      document.addEventListener('cart:updated', this.handleCartUpdate);
      this.setSize(this.getSelectedSize());
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handleDocumentChange);
      document.removeEventListener('cart:updated', this.handleCartUpdate);
      this.boundProductForms.forEach((form) => form.removeEventListener('submit', this.handleProductFormSubmit));
      if (this.cartCheckTimer) window.clearTimeout(this.cartCheckTimer);
    }

    getSelectedSize() {
      const scope = this.closest('product-information, .product-information, .shopify-section') || document;
      const picker = scope.querySelector('variant-picker, swatches-variant-picker-component');
      const checkedValues = picker ? Array.from(picker.querySelectorAll('input:checked')).map((input) => input.value) : [];
      const selectedValues = picker
        ? Array.from(picker.querySelectorAll('select')).map((select) => select.selectedOptions[0]?.value)
        : [];
      const selectedSize = [...checkedValues, ...selectedValues].find((value) => {
        const normalized = String(value || '').trim().toUpperCase();
        return ['A3', 'A4', 'A5', 'POCKET', 'POCKET SIZE'].includes(normalized);
      });
      const initialSize = String(selectedSize || this.dataset.initialSize || 'A4').trim().toUpperCase();
      return initialSize;
    }

    handleVariantChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (!target.closest('variant-picker, swatches-variant-picker-component')) return;
      const nextSize = String(target.value || '').trim().toUpperCase();
      this.setSize(nextSize);
    }

    setSize(nextSize) {
      const normalizedSize = String(nextSize || '').trim().toUpperCase();
      const isEligibleSize = normalizedSize === 'A3' || normalizedSize === 'A4';
      this.hidden = !isEligibleSize;
      this.setAttribute('aria-hidden', isEligibleSize ? 'false' : 'true');
      if (!isEligibleSize) return;
      this.size = normalizedSize;
      this.dataset.selectedSize = normalizedSize;
      this.storageKey = `poster-combo-offer-${window.Shopify?.shop || window.location.host}-${normalizedSize}`;
      if (this.heading) this.heading.textContent = 'Buy More, Get More Free';
      if (this.subheading) this.subheading.textContent = `Choose an ${normalizedSize} offer — discount applies automatically`;
      if (this.cardsContainer) this.cardsContainer.setAttribute('aria-label', `Automatic ${normalizedSize} poster offers`);
      this.configureCards();
      this.restoreOffer();
      this.dispatchEvent(new CustomEvent('poster-combo:size-change', {
        bubbles: true,
        detail: { size: normalizedSize }
      }));
    }

    configureCards() {
      const offers = this.offerSets[this.size];
      this.cards.forEach((card, index) => {
        const offer = offers[index];
        if (!offer) return;
        card.dataset.tier = offer.tier;
        card.dataset.quantity = String(offer.quantity);
        card.dataset.price = offer.price;
        card.dataset.discountCode = offer.discountCode;
        card.dataset.ribbon = offer.ribbon;
        const ribbon = card.querySelector('.poster-combo-offers__ribbon');
        const title = card.querySelector('.poster-combo-offers__offer-title');
        const price = card.querySelector('.poster-combo-offers__price');
        const unitPrice = card.querySelector('.poster-combo-offers__unit-price');
        const discount = card.querySelector('.poster-combo-offers__discount');
        if (ribbon) ribbon.textContent = offer.ribbon;
        if (title) title.textContent = offer.label.toUpperCase().replace(' GET ', ', GET ');
        if (price) price.textContent = `${offer.quantity} for ₹${offer.price}`;
        if (unitPrice) unitPrice.textContent = `${this.size} · ₹${offer.unitPrice} per poster`;
        if (discount) discount.textContent = 'NO CODE NEEDED';
      });
    }

    findProductForms() {
      const productForm = this.closest('product-information, .product-information, .shopify-section')?.querySelector('form[data-type="add-to-cart-form"]');
      if (productForm) return [productForm];
      return Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"]')).filter((form) => {
        const productInput = form.querySelector('input[name="id"]');
        return productInput && form.closest('product-form-component')?.dataset.productId === this.dataset.productId;
      });
    }

    handleKeydown(event, card) {
      const currentIndex = this.cards.indexOf(card);
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.cards.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.cards.length) % this.cards.length;
      if (nextIndex === null) return;
      event.preventDefault();
      this.cards[nextIndex].focus();
      this.selectOffer(this.cards[nextIndex], true);
    }

    restoreOffer() {
      let storedOffer = null;
      try {
        storedOffer = JSON.parse(window.localStorage.getItem(this.storageKey));
      } catch (error) {
        storedOffer = null;
      }
      const storedCard = storedOffer
        ? this.cards.find((item) => item.dataset.tier === String(storedOffer.tier))
        : null;
      const defaultCard = this.cards.find((item) => item.dataset.tier === this.dataset.defaultTier);
      this.selectOffer(storedCard || defaultCard || this.cards[0], false);
    }

    async selectOffer(card, shouldSyncCart) {
      if (!card) return;
      const offer = {
        size: this.size,
        tier: card.dataset.tier,
        label: this.offerSets[this.size].find((item) => item.tier === card.dataset.tier)?.label || 'Poster offer',
        quantity: Number(card.dataset.quantity),
        price: card.dataset.price,
        ribbon: card.dataset.ribbon,
        discountCode: card.dataset.discountCode
      };
      this.cards.forEach((item) => {
        const selected = item === card;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      this.offer = offer;
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(offer));
      } catch (error) {
      }
      this.applyLineItemProperties();
      this.updateProgress();
      this.dispatchEvent(new CustomEvent('poster-combo:change', { bubbles: true, detail: offer }));
      if (shouldSyncCart) await this.syncCartAttributes();
    }

    applyLineItemProperties() {
      this.productForms = this.findProductForms();
      this.productForms.forEach((form) => {
        if (!this.boundProductForms.has(form)) {
          form.addEventListener('submit', this.handleProductFormSubmit);
          this.boundProductForms.add(form);
        }
        const values = {
          '_poster_combo_size': this.offer.size,
          '_poster_combo_tier': this.offer.tier,
          '_poster_combo_target_quantity': String(this.offer.quantity),
          '_poster_combo_price': this.offer.price,
          '_poster_combo_discount_code': this.offer.discountCode,
          '_poster_combo_source': 'poster-combo-offers'
        };
        Object.entries(values).forEach(([key, value]) => {
          let input = form.querySelector(`input[data-poster-combo-property="${key}"]`);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            input.dataset.posterComboProperty = key;
            form.appendChild(input);
          }
          input.value = value;
        });
      });
    }

    monitorCartAfterSubmit() {
      if (!this.offer) return;
      if (this.cartCheckTimer) window.clearTimeout(this.cartCheckTimer);
      const expectedCode = this.offer.discountCode;
      const startingQuantity = this.lastSelectedQuantity;
      let attempts = 0;
      const checkCart = async () => {
        if (!this.isConnected || this.offer?.discountCode !== expectedCode) return;
        attempts += 1;
        const selectedQuantity = await this.updateProgress();
        if (selectedQuantity >= this.offer.quantity) return;
        if (startingQuantity !== null && selectedQuantity !== startingQuantity) return;
        if (attempts < 20) this.cartCheckTimer = window.setTimeout(checkCart, 300);
      };
      this.cartCheckTimer = window.setTimeout(checkCart, 300);
    }

    async syncCartAttributes() {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              poster_combo_size: this.offer.size,
              poster_combo_tier: this.offer.tier,
              poster_combo_target_quantity: String(this.offer.quantity),
              poster_combo_price: this.offer.price,
              poster_combo_discount_code: this.offer.discountCode,
              poster_combo_source: 'poster-combo-offers'
            }
          })
        });
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
      }
    }

    async updateProgress() {
      if (!this.offer || !this.progress) return 0;
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        const selectedQuantity = cart.items.reduce((total, item) => {
          const properties = item.properties || {};
          const matchesOffer = properties._poster_combo_source === 'poster-combo-offers';
          return matchesOffer ? total + item.quantity : total;
        }, 0);
        this.lastSelectedQuantity = selectedQuantity;
        const remaining = Math.max(this.offer.quantity - selectedQuantity, 0);
        if (remaining > 0) {
          this.progress.textContent = `${selectedQuantity} of ${this.offer.quantity} posters added. Add ${remaining} more in any A4/A3 mix.`;
        } else {
          this.progress.textContent = `${this.offer.quantity} of ${this.offer.quantity} posters added. ${this.offer.label} applies automatically.`;
        }
        return selectedQuantity;
      } catch (error) {
        this.progress.textContent = `${this.offer.label} · ${this.offer.size} set of ${this.offer.quantity} for ₹${this.offer.price}.`;
        return this.lastSelectedQuantity || 0;
      }
    }
  }

  if (!customElements.get('poster-combo-offers')) customElements.define('poster-combo-offers', PosterComboOffers);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["poster-frame-selector"] && !Shopify.designMode) return;
  try {
    class PosterFrameSelector extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-frame-key]'));
      this.status = this.querySelector('[data-frame-status]');
      this.note = this.querySelector('[data-frame-note]');
      this.scope = this.getScope();
      this.isAdding = false;
      this.handleDocumentChange = (event) => this.handleVariantChange(event);
      this.handleClick = (event) => this.handleAddButtonClick(event);
      this.handleSubmit = (event) => this.addPosterWithFrame(event);
      this.options.forEach((option) => option.addEventListener('click', () => this.selectFrame(option)));
      document.addEventListener('change', this.handleDocumentChange);
      this.scope.addEventListener('click', this.handleClick, true);
      this.scope.addEventListener('submit', this.handleSubmit, true);
      this.setSize(this.getSelectedSize());
      this.selectFrame(this.options[0]);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handleDocumentChange);
      this.scope?.removeEventListener('click', this.handleClick, true);
      this.scope?.removeEventListener('submit', this.handleSubmit, true);
    }

    normalizeSize(value) {
      const normalized = String(value || '').trim().toUpperCase();
      if (normalized.startsWith('A3')) return 'A3';
      if (normalized.startsWith('A4')) return 'A4';
      return null;
    }

    getScope() {
      return this.closest('product-information, .product-information, .shopify-section') || document;
    }

    getSelectedSize() {
      const picker = this.getScope().querySelector('variant-picker, swatches-variant-picker-component');
      const checkedValues = picker ? Array.from(picker.querySelectorAll('input:checked')).map((input) => input.value) : [];
      const selectedValues = picker
        ? Array.from(picker.querySelectorAll('select')).map((select) => select.selectedOptions[0]?.value)
        : [];
      const currentValues = [...checkedValues, ...selectedValues].filter(Boolean);
      if (currentValues.length) {
        return currentValues.map((value) => this.normalizeSize(value)).find(Boolean) || null;
      }
      return this.normalizeSize(this.dataset.initialSize);
    }

    handleVariantChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (!target.closest('variant-picker, swatches-variant-picker-component')) return;
      requestAnimationFrame(() => this.setSize(this.getSelectedSize()));
    }

    setSize(size) {
      if (size !== 'A3' && size !== 'A4') {
        this.hidden = true;
        this.size = null;
        const noFrame = this.options.find((option) => option.dataset.frameKey === 'none');
        if (noFrame && this.selection?.key !== 'none') this.selectFrame(noFrame);
        return;
      }
      this.hidden = false;
      this.size = size === 'A3' ? 'A3' : 'A4';
      this.options.forEach((option) => {
        if (option.dataset.frameKey === 'none') return;
        const priceElement = option.querySelector('[data-frame-price]');
        if (option.dataset.frameSoldOut === 'true') {
          if (priceElement) priceElement.textContent = 'OUT OF STOCK';
          return;
        }
        const price = this.size === 'A3' ? option.dataset.priceA3 : option.dataset.priceA4;
        if (priceElement) priceElement.textContent = `Add Frame +₹${price}`;
      });
      if (this.selection) this.selectFrame(this.selection.element);
    }

    selectFrame(option) {
      if (!option || option.dataset.frameSoldOut === 'true') return;
      const key = option.dataset.frameKey;
      const isA3 = this.size === 'A3';
      const price = key === 'none' ? '0' : (isA3 ? option.dataset.priceA3 : option.dataset.priceA4);
      const variantId = key === 'none' ? null : (isA3 ? option.dataset.variantA3 : option.dataset.variantA4);
      this.selection = {
        element: option,
        key,
        name: option.dataset.frameName,
        price,
        variantId
      };
      this.options.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (this.status) {
        this.status.textContent = key === 'none'
          ? 'Selected: No Frame'
          : `Selected: ${this.size} ${this.selection.name} Frame (+₹${price})`;
      }
      if (this.note) this.note.hidden = key === 'none';
      this.getScope().classList.toggle('poster-frame-selected', key !== 'none');
      this.applyPosterProperties();
    }

    findProductForms() {
      const scope = this.getScope();
      const forms = Array.from(scope.querySelectorAll('form[data-type="add-to-cart-form"]'));
      return forms.filter((form) => form.querySelector('input[name="id"]'));
    }

    applyPosterProperties() {
      this.findProductForms().forEach((form) => {
        form.querySelectorAll('[data-frame-poster-property]').forEach((input) => input.remove());
        if (!this.selection || this.selection.key === 'none') return;
        const values = {
          '_frame_addon': 'Yes',
          '_frame_style': this.selection.name,
          '_frame_size': this.size
        };
        Object.entries(values).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = value;
          input.dataset.framePosterProperty = key;
          form.appendChild(input);
        });
      });
    }

    async comboRedirect(form, addedQuantity) {
      const codeInput = form.querySelector('[data-poster-combo-property="_poster_combo_discount_code"]');
      const targetInput = form.querySelector('[data-poster-combo-property="_poster_combo_target_quantity"]');
      const sizeInput = form.querySelector('[data-poster-combo-property="_poster_combo_size"]');
      const code = codeInput?.value;
      const target = Number(targetInput?.value || 0);
      const comboSize = this.normalizeSize(sizeInput?.value);
      if (!code || !target || !comboSize) return '/cart';

      let currentQuantity = 0;
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        currentQuantity = cart.items.reduce((total, item) => {
          const properties = item.properties || {};
          const itemSize = this.normalizeSize(properties._poster_combo_size || item.variant_title);
          const isPosterCombo = properties._poster_combo_source === 'poster-combo-offers';
          return isPosterCombo && itemSize === comboSize ? total + item.quantity : total;
        }, 0);
      } catch (error) {
      }

      return currentQuantity + addedQuantity >= target
        ? `/discount/${encodeURIComponent(code)}?redirect=/cart`
        : '/cart';
    }

    handleAddButtonClick(event) {
      if (!this.selection || this.selection.key === 'none' || this.isAdding) return;
      const submitter = event.target.closest('button[type="submit"], input[type="submit"]');
      const form = submitter?.form;
      if (!(form instanceof HTMLFormElement) || !this.findProductForms().includes(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.addPosterAndFrame(form, submitter);
    }

    addPosterWithFrame(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !this.findProductForms().includes(form)) return;
      if (!this.selection || this.selection.key === 'none' || this.isAdding) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.addPosterAndFrame(form, event.submitter);
    }

    async addPosterAndFrame(form, submitter) {
      if (!form.reportValidity()) return;
      this.isAdding = true;
      if (submitter) submitter.disabled = true;
      const quantityInput = form.querySelector('input[name="quantity"]');
      const quantity = Math.max(Number(quantityInput?.value || 1), 1);

      try {
        const redirect = await this.comboRedirect(form, quantity);
        const posterData = new FormData(form);
        posterData.delete('return_to');
        const posterResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: posterData
        });
        if (!posterResponse.ok) throw new Error('Poster could not be added');

        const frameResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(this.selection.variantId),
              quantity,
              properties: {
                '_frame_for_product': this.dataset.productId,
                '_frame_for_variant': form.querySelector('input[name="id"]')?.value || '',
                '_frame_size': this.size,
                '_frame_style': this.selection.name
              }
            }]
          })
        });
        if (!frameResponse.ok) throw new Error('Frame could not be added');
        window.location.assign(redirect);
      } catch (error) {
        this.isAdding = false;
        if (submitter) submitter.disabled = false;
        if (this.status) this.status.textContent = 'We could not add the frame. Please try again.';
      }
    }
  }

  if (!customElements.get('poster-frame-selector')) {
    customElements.define('poster-frame-selector', PosterFrameSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["split-poster-combo-offers"] && !Shopify.designMode) return;
  try {
    class SplitPosterComboOffers extends HTMLElement {
    connectedCallback() {
      this.offerSets = {
        A4: [
          {
            tier: '3',
            quantity: 3,
            price: '449',
            code: 'SPLITCOMBO3',
            label: 'Any 3 A4 Split Posters',
            title: 'ANY 3 SPLIT POSTERS',
            compareHtml: '<s>₹537</s> · Save ₹88',
            ribbon: ''
          },
          {
            tier: '5',
            quantity: 5,
            price: '699',
            code: 'SPLITCOMBO5',
            label: 'Buy 4 A4 Split Posters, Get 1 Free',
            title: 'BUY 4, GET 1 FREE',
            compareHtml: '5 posters · <s>₹895</s> · Save ₹196',
            ribbon: 'BEST VALUE'
          }
        ],
        A3: [
          {
            tier: '3',
            quantity: 3,
            price: '649',
            code: 'A3SPLITCOMBO3',
            label: 'Any 3 A3 Split Posters',
            title: 'ANY 3 A3 SPLIT POSTERS',
            compareHtml: '<s>₹747</s> · Save ₹98',
            ribbon: ''
          },
          {
            tier: '5',
            quantity: 5,
            price: '999',
            code: 'A3SPLITCOMBO5',
            label: 'Any 5 A3 Split Posters',
            title: 'ANY 5 A3 SPLIT POSTERS',
            compareHtml: '<s>₹1,245</s> · Save ₹246',
            ribbon: 'BEST VALUE'
          }
        ]
      };
      this.cards = Array.from(this.querySelectorAll('[data-tier]'));
      this.cardsContainer = this.querySelector('.split-poster-combo__cards');
      this.heading = this.querySelector('[data-split-combo-heading]');
      this.subheading = this.querySelector('[data-split-combo-subheading]');
      this.progress = this.querySelector('[data-split-combo-progress]');
      this.boundForms = new Set();
      this.cartCheckTimer = null;
      this.lastSelectedQuantity = null;
      this.discountRedirectPending = false;
      this.handleFormSubmit = (event) => this.prepareFormSubmit(event);
      this.handleDocumentChange = (event) => this.handleVariantChange(event);
      this.handleCartUpdate = () => this.updateProgress();
      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.selectOffer(card, true));
        card.addEventListener('keydown', (event) => this.handleKeydown(event, card));
      });
      document.addEventListener('change', this.handleDocumentChange);
      document.addEventListener('cart:updated', this.handleCartUpdate);
      this.setSize(this.getSelectedSize());
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handleDocumentChange);
      document.removeEventListener('cart:updated', this.handleCartUpdate);
      this.boundForms.forEach((form) => form.removeEventListener('submit', this.handleFormSubmit));
      if (this.cartCheckTimer) window.clearTimeout(this.cartCheckTimer);
    }

    normalizeSize(value) {
      const normalized = String(value || '').trim().toUpperCase();
      if (normalized.startsWith('A3')) return 'A3';
      if (normalized.startsWith('A4')) return 'A4';
      return null;
    }

    getSelectedSize() {
      const scope = this.closest('product-information, .product-information, .shopify-section') || document;
      const picker = scope.querySelector('variant-picker, swatches-variant-picker-component');
      const checkedValues = picker ? Array.from(picker.querySelectorAll('input:checked')).map((input) => input.value) : [];
      const selectedValues = picker
        ? Array.from(picker.querySelectorAll('select')).map((select) => select.selectedOptions[0]?.value)
        : [];
      const selectedSize = [...checkedValues, ...selectedValues]
        .map((value) => this.normalizeSize(value))
        .find(Boolean);
      return selectedSize || this.normalizeSize(this.dataset.initialSize) || 'A4';
    }

    handleVariantChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (!target.closest('variant-picker, swatches-variant-picker-component')) return;
      const nextSize = this.normalizeSize(target.value);
      if (!nextSize) return;
      this.setSize(nextSize);
    }

    setSize(nextSize) {
      const normalizedSize = nextSize === 'A3' ? 'A3' : 'A4';
      this.size = normalizedSize;
      this.dataset.selectedSize = normalizedSize;
      this.storageKey = `split-poster-combo-${window.Shopify?.shop || window.location.host}-${normalizedSize}`;
      if (this.heading) this.heading.textContent = `${normalizedSize} SPLIT POSTER OFFERS`;
      if (this.subheading) {
        const singlePrice = normalizedSize === 'A3' ? '249' : '179';
        this.subheading.textContent = `1 ${normalizedSize} Split Poster — ₹${singlePrice} · Mix any designs`;
      }
      if (this.cardsContainer) this.cardsContainer.setAttribute('aria-label', `${normalizedSize} Split Poster bundle offers`);
      this.configureCards();
      this.restoreOffer();
    }

    configureCards() {
      const offers = this.offerSets[this.size];
      this.cards.forEach((card, index) => {
        const offer = offers[index];
        if (!offer) return;
        card.dataset.tier = offer.tier;
        card.dataset.quantity = String(offer.quantity);
        card.dataset.price = offer.price;
        card.dataset.code = offer.code;
        card.dataset.label = offer.label;
        const ribbon = card.querySelector('.split-poster-combo__ribbon');
        const title = card.querySelector('.split-poster-combo__title');
        const price = card.querySelector('.split-poster-combo__price');
        const compare = card.querySelector('.split-poster-combo__compare');
        const code = card.querySelector('.split-poster-combo__code');
        if (ribbon) {
          ribbon.textContent = offer.ribbon;
          ribbon.hidden = !offer.ribbon;
        }
        if (title) title.textContent = offer.title;
        if (price) price.textContent = `₹${offer.price}`;
        if (compare) compare.innerHTML = offer.compareHtml;
        if (code) code.textContent = `USE CODE: ${offer.code}`;
      });
    }

    findProductForms() {
      const form = this.closest('product-information, .product-information, .shopify-section')?.querySelector('form[data-type="add-to-cart-form"]');
      return form ? [form] : [];
    }

    restoreOffer() {
      let storedOffer = null;
      try {
        storedOffer = JSON.parse(window.localStorage.getItem(this.storageKey));
      } catch (error) {
        storedOffer = null;
      }
      const storedCard = storedOffer
        ? this.cards.find((card) => card.dataset.tier === String(storedOffer.tier))
        : null;
      const defaultCard = this.cards.find((card) => card.dataset.tier === this.dataset.defaultTier);
      this.selectOffer(storedCard || defaultCard || this.cards[0], false);
    }

    handleKeydown(event, card) {
      const currentIndex = this.cards.indexOf(card);
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.cards.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.cards.length) % this.cards.length;
      if (nextIndex === null) return;
      event.preventDefault();
      this.cards[nextIndex].focus();
      this.selectOffer(this.cards[nextIndex], true);
    }

    async selectOffer(card, shouldSyncCart) {
      if (!card) return;
      this.offer = {
        tier: card.dataset.tier,
        quantity: Number(card.dataset.quantity),
        price: card.dataset.price,
        code: card.dataset.code,
        label: card.dataset.label
      };
      this.cards.forEach((item) => {
        const selected = item === card;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(this.offer));
      } catch (error) {
      }
      this.applyLineItemProperties();
      this.updateProgress();
      if (shouldSyncCart) await this.syncCartAttributes();
    }

    applyLineItemProperties() {
      this.findProductForms().forEach((form) => {
        if (!this.boundForms.has(form)) {
          form.addEventListener('submit', this.handleFormSubmit);
          this.boundForms.add(form);
        }
        const values = {
          '_split_combo_size': this.size,
          '_split_combo_tier': this.offer.tier,
          '_split_combo_target_quantity': String(this.offer.quantity),
          '_split_combo_price': this.offer.price,
          '_split_combo_discount_code': this.offer.code,
          '_split_combo_source': 'split-poster-combo'
        };
        Object.entries(values).forEach(([key, value]) => {
          let input = form.querySelector(`input[data-split-combo-property="${key}"]`);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            input.dataset.splitComboProperty = key;
            form.appendChild(input);
          }
          input.value = value;
        });
      });
    }

    prepareFormSubmit(event) {
      if (!this.offer) return;
      const form = event.currentTarget;
      const quantityInput = form.querySelector('input[name="quantity"]');
      const addedQuantity = Math.max(Number(quantityInput?.value || 1), 1);
      const projectedQuantity = (this.lastSelectedQuantity || 0) + addedQuantity;
      let returnToInput = form.querySelector('input[data-split-combo-return-to]');

      if (projectedQuantity >= this.offer.quantity) {
        if (!returnToInput) {
          returnToInput = document.createElement('input');
          returnToInput.type = 'hidden';
          returnToInput.name = 'return_to';
          returnToInput.dataset.splitComboReturnTo = 'true';
          form.appendChild(returnToInput);
        }
        returnToInput.value = `/discount/${encodeURIComponent(this.offer.code)}?redirect=/cart`;
      } else if (returnToInput) {
        returnToInput.remove();
      }

      this.monitorCartAfterSubmit();
    }

    async syncCartAttributes() {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              split_combo_size: this.size,
              split_combo_tier: this.offer.tier,
              split_combo_target_quantity: String(this.offer.quantity),
              split_combo_price: this.offer.price,
              split_combo_discount_code: this.offer.code,
              split_combo_source: 'split-poster-combo'
            }
          })
        });
      } catch (error) {
      }
    }

    monitorCartAfterSubmit() {
      if (!this.offer) return;
      if (this.cartCheckTimer) window.clearTimeout(this.cartCheckTimer);
      const expectedCode = this.offer.code;
      const expectedSize = this.size;
      const startingQuantity = this.lastSelectedQuantity;
      let attempts = 0;
      const checkCart = async () => {
        if (!this.isConnected || this.offer?.code !== expectedCode || this.size !== expectedSize) return;
        attempts += 1;
        const selectedQuantity = await this.updateProgress();
        if (selectedQuantity >= this.offer.quantity) return;
        if (startingQuantity !== null && selectedQuantity !== startingQuantity) return;
        if (attempts < 20) this.cartCheckTimer = window.setTimeout(checkCart, 300);
      };
      this.cartCheckTimer = window.setTimeout(checkCart, 300);
    }

    async updateProgress() {
      if (!this.offer || !this.progress) return 0;
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        const selectedQuantity = cart.items.reduce((total, item) => {
          const properties = item.properties || {};
          const itemSize = this.normalizeSize(properties._split_combo_size || item.variant_title);
          const isSplitPoster = properties._split_combo_source === 'split-poster-combo';
          return isSplitPoster && itemSize === this.size ? total + item.quantity : total;
        }, 0);
        this.lastSelectedQuantity = selectedQuantity;
        const remaining = Math.max(this.offer.quantity - selectedQuantity, 0);
        if (remaining > 0) {
          this.progress.textContent = `${selectedQuantity} of ${this.offer.quantity} ${this.size} Split Posters added. Add ${remaining} more in any mix.`;
          this.discountRedirectPending = false;
          try {
            window.sessionStorage.removeItem(`split-poster-code-${this.offer.code}`);
          } catch (error) {
          }
        } else {
          this.progress.textContent = `${this.offer.quantity} of ${this.offer.quantity} ${this.size} Split Posters added. Applying your offer…`;
          this.applyDiscountCode();
        }
        return selectedQuantity;
      } catch (error) {
        this.progress.textContent = `Selected: ${this.offer.label} for ₹${this.offer.price}.`;
        return this.lastSelectedQuantity || 0;
      }
    }

    applyDiscountCode() {
      if (!this.offer?.code || this.discountRedirectPending) return;
      const applyKey = `split-poster-code-${this.offer.code}`;
      try {
        if (window.sessionStorage.getItem(applyKey) === 'applied') return;
        window.sessionStorage.setItem(applyKey, 'applied');
      } catch (error) {
      }
      this.discountRedirectPending = true;
      window.location.assign(`/discount/${encodeURIComponent(this.offer.code)}?redirect=/cart`);
    }
  }

  if (!customElements.get('split-poster-combo-offers')) {
    customElements.define('split-poster-combo-offers', SplitPosterComboOffers);
  }
  } catch(e) { console.error(e); }
})();

})();
